import { Flex, Stack, Text } from '@instamenu/ui-system-next';
import { BackButton } from '../back-button/back-button';
import { PaymentMethodForm } from '../payment-method-form/payment-method-form';
import { PaymentMethod } from '@stripe/stripe-js';

type AddPaymentFormProps = {
  onSubmit: (paymentMethod: PaymentMethod) => void;
  onBack: () => void;
};

export const AddPaymentForm = ({ onSubmit, onBack }: AddPaymentFormProps) => (
  <Stack>
    <Flex style={{ alignItems: 'center', justifyContent: 'space-between', paddingBottom: 24 }}>
      <BackButton label="" onClick={onBack} />
      <Text
        css={{
          flex: 1,
          margin: 0,
          fontSize: 17,
          fontWeight: 500,
          marginRight: 38,
          textAlign: 'center',
        }}
      >
        Add Payment Method
      </Text>
    </Flex>
    <PaymentMethodForm returnUrl={window.location.href} onSubmit={onSubmit} />
  </Stack>
);
